import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import Button from 'shared/lib/components/Button';
import moment from 'moment-timezone';
import filter from 'lodash/filter';
import { startClaim, getClaimsHistory } from '../../store/actions';
import { AdvanceList, AdvanceListItem } from '../../components/AdvanceList';
import IconCircle from 'shared/lib/components/IconCircle';
import Spinner from 'shared/lib/components/Spinner';
import ClaimsContact from '../../components/ClaimsContact';
import * as analytics from 'shared/lib/analytics';
import './ClaimsIndex.css';

class ClaimsIndex extends Component {
  componentDidMount() {
    document.title = 'Claims - Sure';
    this.props.getClaimsHistory().then(() => {
      analytics.page('Portal - Claims Index', {
        category: 'claim',
        value: this.props.pendingClaims.length + this.props.pastClaims.length,
      });
    });
  }

  get loadingStateNode() {
    return (
      <div className="ClaimsIndex-loadingState Container Container--small">
        <Spinner />
        <h1 className="ClaimsIndex-heading">Fetching your claims history...</h1>
      </div>
    );
  }

  get zeroStateNode() {
    return (
      <div className="ClaimsIndex-zeroState Container Container--small">
        <IconCircle
          className="ClaimsIndex-zeroState-icon"
          icon="assignment"
          color="medium"
          background="gray"
        />
        <h1 className="ClaimsIndex-heading">No claims pending</h1>
        <Button onClick={this.handleStartClaim.bind(this)}>
          Start a claim
        </Button>
        <p className="ClaimsIndex-disclaimer">
          Remember: Insurance fraud is a serious crime. 99.8% of cases result in
          legal action.
        </p>
      </div>
    );
  }

  get pendingClaimsNode() {
    const claimsListItems = this.props.pendingClaims.map(claim => {
      const link = `/account/claims/${claim.claim_id}`;
      const title = `${claim.policy_details.plan_name} Smartphone (Claim ID #${
        claim.claim_id
      })`;
      const details = [
        `Submitted ${moment(claim.submitted).format('MMM D, YYYY')}`,
        claim.policy_details.device_model,
        `Policy #${claim.policy_number}`,
      ];
      return (
        <AdvanceListItem
          key={claim.claim_id}
          title={title}
          details={details}
          linkTo={link}
        />
      );
    });

    return (
      <div>
        <h1 className="ClaimsIndex-heading">Pending Claims</h1>
        <AdvanceList className="ClaimsIndex-list">
          {claimsListItems}
        </AdvanceList>
      </div>
    );
  }

  get pastClaimsNode() {
    const claimsListItems = this.props.pastClaims.map(claim => {
      const link = `/account/claims/${claim.claim_id}`;
      const title = `${claim.policy_details.plan_name} Smartphone (Claim ID #${
        claim.claim_id
      })`;
      const details = [
        `Submitted ${moment(claim.submitted).format('MMM D, YYYY')}`,
        claim.policy_details.device_model,
        `Policy #${claim.policy_number}`,
      ];
      return (
        <AdvanceListItem
          key={claim.claim_id}
          title={title}
          details={details}
          linkTo={link}
        />
      );
    });

    return (
      <div>
        <h1 className="ClaimsIndex-heading">Past Claims</h1>
        <AdvanceList className="ClaimsIndex-list">
          {claimsListItems}
        </AdvanceList>
      </div>
    );
  }

  get claimsHistoryNode() {
    return (
      <div className="ClaimsIndex-content Container Container--small">
        {(this.props.pendingClaims.length && this.pendingClaimsNode) || null}
        {(this.props.pastClaims.length && this.pastClaimsNode) || null}
        <Button onClick={this.handleStartClaim.bind(this)}>
          Start a claim
        </Button>
        <p className="ClaimsIndex-disclaimer">
          Remember: Insurance fraud is a serious crime. 99.8% of cases result in
          legal action.
        </p>
      </div>
    );
  }

  get contentNode() {
    if (this.props.isFetchingClaims) {
      return this.loadingStateNode;
    } else if (process.env.REACT_APP_IS_SMARTPHONE_CLAIMS_ENABLED) {
      if (this.props.pendingClaims.length || this.props.pastClaims.length) {
        return this.claimsHistoryNode;
      } else {
        return this.zeroStateNode;
      }
    } else {
      return (
        <ClaimsContact
          params={this.props.params}
          orders={this.props.policiesById}
          phoneNumber={
            this.props.claimsProcessInstructions.support_phone_number
          }
        />
      );
    }
  }

  handleStartClaim() {
    analytics.track('Portal - Start Claim Clicked', {
      category: 'claim',
      value: this.props.pendingClaims.length + this.props.pastClaims.length,
    });
    this.props.startClaim();
  }

  render() {
    return <div className="ClaimsIndex">{this.contentNode}</div>;
  }
}

const mapStateToProps = state => {
  return {
    pendingClaims: filter(state.claims, claim => {
      return claim.status === 'submitted' || claim.status === 'handed_off';
    }),
    pastClaims: filter(state.claims, 'resolution'),
    isFetchingClaims: state.isFetchingClaims,
    claimsProcessInstructions: state.claimsProcessInstructions,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClaimsHistory: () => dispatch(getClaimsHistory()),
    startClaim: () => {
      dispatch(startClaim());
      dispatch(push('/account/claims/new'));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ClaimsIndex));
